// AddViewSupport49Component.jsx
import React, { useEffect, useMemo, useState } from "react";
import {
  Container,
  Row,
  Col,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  Table,
  Badge,
} from "reactstrap";
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import DatePicker, { registerLocale } from "react-datepicker";
import { utcToZonedTime } from "date-fns-tz";
import { format, parseISO } from "date-fns";
import th from "date-fns/locale/th";
import { th as thBuddhist } from "date-fns/esm/locale";
import { addYears } from "date-fns/esm/fp";
import getYear from "date-fns/getYear";
import getMonth from "date-fns/getMonth";
import "react-datepicker/dist/react-datepicker.css";
import { BsPlusCircle } from "react-icons/bs";

// ---------- Locale & helpers ----------
registerLocale("th-buddhist", {
  ...th,
  options: { ...th.options, weekStartsOn: 1 },
  formatLong: thBuddhist.formatLong,
});
const thaiMonths = ["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"];
const range = (s, e) => new Array(e - s).fill().map((_, i) => i + s);
const years = range(1963, new Date().getFullYear() + 8);

const fmtMoney = (n) =>
  Number(n || 0).toLocaleString(undefined, { maximumFractionDigits: 2 });
const toThaiDateLabel = (iso) => {
  if (!iso) return "-";
  const d = typeof iso === "string" ? parseISO(iso) : iso;
  const be = addYears(543, d);
  return `${format(be, "dd")} ${format(be, "MMMM", { locale: th })} ${format(be, "yyyy")}`;
};
const parseYearMonth = (yyyymm) => {
  const [y, m] = (yyyymm || "").split("-").map(Number);
  return { y, m };
};
const sameMonth = (iso, y, m) => {
  const d = typeof iso === "string" ? parseISO(iso) : iso;
  return d.getFullYear() === y && d.getMonth() + 1 === m;
};
const formatMonthYearBE = (date) => {
  if (!date) return "";
  const be = addYears(543, date);
  return format(be, "MMMM yyyy", { locale: th }); // “ธันวาคม 2568”
};

// ---------- API PATHS (แก้ได้ตาม backend ของคุณ) ----------
const API_BASE = "/api/Support/report49";
const API = {
  CHECK: `${API_BASE}/check`,   // GET ?month=YYYY-MM&deptId=...
  GET: `${API_BASE}/get`,       // GET ?month=YYYY-MM&deptId=...
  ITEM: `${API_BASE}/item`,     // POST (create/update)
  DEL: (id, deptId) => `${API_BASE}/item/${id}?deptId=${encodeURIComponent(deptId)}`, // DELETE
  SAVE: `${API_BASE}/save`,     // POST (header: allocatedBudget/status)
};

// ==========================================================
export function AddViewSupport48Component() {
  const user = JSON.parse(localStorage.getItem("userData") || "{}");
  const deptId = user?.deptId || "";

  // รอบรายงาน (UI เป็น Date, ส่ง API เป็น YYYY-MM)
  const [reportMonth, setReportMonth] = useState(""); // "YYYY-MM"
  const [reportMonthDate, setReportMonthDate] = useState(null); // Date(วัน = 1)

  const [loading, setLoading] = useState(false);
  const [isEditingReport, setIsEditingReport] = useState(false);

  // master
  const [lawOcuData, setLawOcuData] = useState([]);
  console.log("lawOcuData", lawOcuData);
  const [testLawOcuData, setTestLawOcuData] = useState([]);

  // รายการ + งบ
  const [items, setItems] = useState([]);
  console.log("items", items);
  const [allocatedBudget, setAllocatedBudget] = useState(0);

  // modal
  const [openModal, setOpenModal] = useState(false);
  const [editingItem, setEditingItem] = useState(null);

  // โหลด master
  useEffect(() => {
    (async () => {
      try {
        const res = await fetch("/api/Borrow/getLawOcuData");
        const j = await res.json();
        setLawOcuData(j?.dataenum || []);
      } catch { }
    })();
  }, []);

  const loadTestOcc = async (lawOcuId) => {
    try {
      const fd = new FormData();
      fd.append("lawOcuId", lawOcuId);
      const res = await fetch("/api/Borrow/getLawOcuDataDetail", { method: "POST", body: fd });
      const j = await res.json();
      setTestLawOcuData(j?.dataenum || []);
    } catch { }
  };

  // sync UI Month BE <-> API month AD
  useEffect(() => {
    if (!reportMonth) { setReportMonthDate(null); return; }
    const [y, m] = reportMonth.split("-").map(Number);
    setReportMonthDate(new Date(y, m - 1, 1));
  }, [reportMonth]);

  // ตรวจ/โหลดรายงานของเดือน
  // ตรวจ/โหลดรายงานของเดือน (ใช้ api: GET /api/Support/getViewdata49)
  const checkAndLoadMonth = async () => {
    if (!reportMonth || !deptId) {
      Swal.fire("กรุณาเลือกรอบรายงาน (เดือน/ปี)", "", "warning");
      return;
    }

    try {
      setLoading(true);

      const q = new URLSearchParams({ monthYear: reportMonth, deptId });
      const res = await fetch(`/api/Support/getViewdata49?${q.toString()}`);
      const j = await res.json();

      if (j?.status !== 1) {
        throw new Error(j?.message || "ไม่สามารถโหลดข้อมูลได้");
      }

      // map AddviewData49 -> รูปแบบ item ของ UI
      // backend fields:
      //  - CompensetionExpense (สะกดแบบนี้) -> compensetionExpense
      //  - PassevaluaTion -> passEvaluation
      //  - PaymentDate: "yyyy-MM-dd"
      const rows = (j?.dataenum || []).map((s, idx) => {
        // const lawName =
        //   lawOcuData.find(x => String(x.lawOccupationId) === String(s.LawOccupationId))?.lawOccupationName || "-";

        return {
          id: s.Id,
          deptId: s.DeptId,
          lawOccupationId: s.LawOccupationId,
          lawOccupationName: s.lawOccupationName,            // ใช้ชื่อจาก master ที่โหลดไว้
          testOccupationId: s.TestOccupationId,
          testOccupationName: s.testOccupationName,
          // testOccupationName: (ถ้าต้องการ อาจต้องโหลดตามสาขาอาชีพก่อน)

          testOccupationLevel: s.TestOccupationLevel || "1",
          personTest: Number(s.PersonTest || 0),
          passEvaluation: Number(s.PassevaluaTion || 0),

          compensetionExpense: Number(s.CompensetionExpense || 0),
          travellingExpense: Number(s.TravellingExpense || 0),
          materialExpense: Number(s.MaterialExpense || 0),

          paymentAmount: Number(s.PaymentAmount || 0), // มีจากหลังบ้าน เผื่อใช้ต่อ
          paymentDate: s.PaymentDate,                  // "yyyy-MM-dd"
          createBy: s.CreateBy || "",
        };
      });

      setItems(j?.dataenum);
      setAllocatedBudget(0);                 // API นี้ไม่ได้ส่งงบมา
      setIsEditingReport(rows.length > 0);   // มีรายการ => ถือว่าโหมดแก้ไข
    } catch (e) {
      console.error(e);
      Swal.fire("โหลดข้อมูลเดือนไม่สำเร็จ", e?.message || "", "error");
      setItems([]);
      setAllocatedBudget(0);
      setIsEditingReport(false);
    } finally {
      setLoading(false);
    }
  };


  // สรุปรวม
  const summary = useMemo(() => {
    const spent = items.reduce((a, r) =>
      a +
      Number(r.compensetionExpense || 0) +
      Number(r.travellingExpense || 0) +
      Number(r.materialExpense || 0)
      , 0);
    const passed = items.reduce((a, r) => a + Number(r.passEvaluation ?? r.passevaluaTion ?? 0), 0);
    const remaining = Math.max(Number(allocatedBudget || 0) - spent, 0);
    return { spent, passed, remaining };
  }, [items, allocatedBudget]);

  // modal handlers
  const openAdd = () => { setEditingItem(null); setOpenModal(true); };
  const openEdit = async (row) => {
    setEditingItem(row);
    setOpenModal(true);
    if (row?.lawOccupationId) await loadTestOcc(row.lawOccupationId);
  };
  const closeModal = () => setOpenModal(false);

  // ลบรายการ
  const deleteItem = async (id) => {
    if (!id) return;
    const ok = await Swal.fire({
      title: "ยืนยันการลบรายการ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "ลบ",
      cancelButtonText: "ยกเลิก",
      confirmButtonColor: "#d33",
    });
    if (!ok.isConfirmed) return;

    try {
      setLoading(true);
      const res = await fetch(API.DEL(id, deptId), { method: "DELETE" });
      const j = await res.json();
      if (j?.status === 1) {
        setItems((prev) => prev.filter((r) => String(r.id || r.Id) !== String(id)));
      } else {
        Swal.fire("ลบไม่สำเร็จ", "", "error");
      }
    } catch {
      Swal.fire("ลบไม่สำเร็จ", "", "error");
    } finally { setLoading(false); }
  };

  // save header (ปรับงบ)
  const saveHeader = async () => {
    if (!reportMonth || !deptId) {
      Swal.fire("กรุณาเลือกรอบรายงาน (เดือน/ปี)", "", "warning");
      return;
    }
    try {
      setLoading(true);
      const body = { Month: reportMonth, DeptId: deptId, AllocatedBudget: Number(allocatedBudget) };
      const res = await fetch(API.SAVE, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });
      const j = await res.json();
      if (j?.status === 1) Swal.fire("บันทึกงบสำเร็จ", "", "success");
      else Swal.fire("บันทึกงบไม่สำเร็จ", "", "warning");
    } catch {
      Swal.fire("บันทึกงบไม่สำเร็จ", "", "error");
    } finally { setLoading(false); }
  };

  // UI
  return (
    <Container className="py-3">


      {/* รอบรายงาน (เดือน/ปี) — แสดง พ.ศ. */}
      <Row className="g-3 align-items-end">
        <Col md={5}>
          <Label>รอบรายงาน (เดือน/ปี)</Label>
          <DatePicker
            selected={reportMonthDate}
            onChange={(date) => {
              if (date instanceof Date && !isNaN(date)) {
                const y = date.getFullYear();
                const m = String(date.getMonth() + 1).padStart(2, "0");
                setReportMonth(`${y}-${m}`);           // AD for API
                setReportMonthDate(new Date(y, Number(m) - 1, 1));
              } else {
                setReportMonth("");
                setReportMonthDate(null);
              }
            }}
            dateFormat="MMMM yyyy"
            showMonthYearPicker
            showFullMonthYearPicker
            locale="th-buddhist"
            placeholderText="เลือกเดือน/ปี (พ.ศ.)"
            renderCustomHeader={({
              date,
              changeYear,
              changeMonth,
              decreaseMonth,
              increaseMonth,
              prevMonthButtonDisabled,
              nextMonthButtonDisabled,
            }) => (
              <div className="d-flex justify-content-between align-items-center px-2 py-1" style={{ gap: 8 }}>
                <button type="button" className="btn btn-sm btn-light" onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>‹</button>
                <div className="d-flex align-items-center" style={{ gap: 8 }}>
                  <select
                    className="form-select form-select-sm"
                    style={{ width: 120 }}
                    value={thaiMonths[getMonth(date)]}
                    onChange={({ target: { value } }) => changeMonth(thaiMonths.indexOf(value))}
                  >
                    {thaiMonths.map((m) => <option key={m} value={m}>{m}</option>)}
                  </select>
                  <select
                    className="form-select form-select-sm"
                    style={{ width: 100 }}
                    value={getYear(date)}
                    onChange={({ target: { value } }) => changeYear(Number(value))}
                  >
                    {years.map((y) => <option key={y} value={y}>{y + 543}</option>)}
                  </select>
                </div>
                <button type="button" className="btn btn-sm btn-light" onClick={increaseMonth} disabled={nextMonthButtonDisabled}>›</button>
              </div>
            )}
            customInput={
              <input
                className="form-control rounded-pill text-center input-color"
                readOnly
                value={formatMonthYearBE(reportMonthDate)}
                placeholder="เลือกเดือน/ปี (พ.ศ.)"
              />
            }
          />
        </Col>

        <Col md="auto" className="pt-4">
          <button className="btn btn-primary" onClick={checkAndLoadMonth} disabled={!reportMonth}>
            ตรวจสอบ/โหลดรายงาน
          </button>
        </Col>

        <Col md="auto" className="pt-4">
          {reportMonth && (
            <Badge color={isEditingReport ? "warning" : "success"} pill className="px-3 py-2">
              {isEditingReport ? "โหมดแก้ไขรายงาน" : "โหมดสร้างรายงานใหม่"}
            </Badge>
          )}
        </Col>
      </Row>

      {/* Summary + งบ */}
      {/* <div className="mt-4 p-3 border rounded">
        <Row className="text-center g-3 align-items-center">
          <Col md={3}>
            <div>งบตามประกาศข้อ 12 (บาท)</div>
            <h5 className="m-0">{fmtMoney(allocatedBudget)}</h5>
          </Col>
          <Col md={3}>
            <div>ใช้ไป (บาท)</div>
            <h5 className="m-0">{fmtMoney(summary.spent)}</h5>
          </Col>
          <Col md={3}>
            <div>คงเหลือ (บาท)</div>
            <h5 className="m-0">{fmtMoney(summary.remaining)}</h5>
          </Col>
          <Col md={3}>
            <div>ผู้ผ่านการทดสอบ (คน)</div>
            <h5 className="m-0">{summary.passed.toLocaleString()}</h5>
          </Col>
        </Row>
        <Row className="g-2 mt-3 align-items-end">
          <Col md={4}>
            <Label>ปรับงบเดือนนี้ (ถ้าต้องการ)</Label>
            <Input
              type="number"
              min="0"
              value={allocatedBudget}
              onChange={(e) => setAllocatedBudget(e.target.value)}
              className="rounded-pill text-center input-color"
            />
          </Col>
          <Col md="auto">
            <button className="btn btn-outline-primary" onClick={saveHeader} disabled={!reportMonth}>
              บันทึกงบเดือนนี้
            </button>
          </Col>
        </Row>
      </div> */}

      {/* ปุ่มเพิ่มรายการ */}
      <div className="d-flex justify-content-end mt-3">
        <button className="btn btn-success" onClick={openAdd} disabled={!reportMonth}>
          <BsPlusCircle className="me-1" /> เพิ่มรายการจ่าย
        </button>
      </div>

      {/* ตารางรายการ */}
      <div className="mt-3">
        <Table bordered responsive>
          <thead className="table-light">
            <tr>
              <th rowSpan="2" className="text-center align-middle">ลำดับ</th>
              <th rowSpan="2" className="text-center align-middle">สาขาอาชีพ</th>
              <th rowSpan="2" className="text-center align-middle">สาขา</th>
              <th rowSpan="2" className="text-center align-middle">ผู้เข้ารับการทดสอบ</th>
              <th rowSpan="2" className="text-center align-middle">ผู้ผ่าน</th>
              <th colSpan="4" className="text-center">เงินช่วยเหลือ/อุดหนุน (บาท)</th>
              <th rowSpan="2" className="text-center align-middle">วันที่จ่าย</th>
              {/* <th rowSpan="2" className="text-center align-middle">จัดการ</th> */}
            </tr>
            <tr>
              <th className="text-center">ค่าตอบแทนนอกเวลา</th>
              <th className="text-center">ค่าเดินทาง</th>
              <th className="text-center">ค่าวัสดุ</th>
              <th className="text-center">รวม</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 && (
              <tr><td colSpan={12} className="text-center">ยังไม่มีรายการ</td></tr>
            )}
            {items.map((r, idx) => {
              const comp = Number(r.compensetionExpense || 0);
              const trav = Number(r.travellingExpense || 0);
              const mat = Number(r.materialExpense || 0);
              const sum = comp + trav + mat;
              return (
                <tr key={r.id || r.Id || idx}>
                  <td className="text-center">{idx + 1}</td>
                  <td className="text-center">{r.lawOccupationName || "-"}</td>
                  <td className="text-center">{r.testOccupationName || r.testOccupationIdName || "-"}</td>
                  <td className="text-center">{(r.personTest ?? 0).toLocaleString()}</td>
                  <td className="text-center">{(r.passEvaluation ?? r.passevaluaTion ?? 0).toLocaleString()}</td>
                  <td className="text-center">{fmtMoney(comp)}</td>
                  <td className="text-center">{fmtMoney(trav)}</td>
                  <td className="text-center">{fmtMoney(mat)}</td>
                  <td className="text-center">{fmtMoney(sum)}</td>
                  <td className="text-center">{toThaiDateLabel(r.paymentDate)}</td>
                  <td className="text-center">
                    <div className="d-flex gap-2 justify-content-center">
                      <button className="btn btn-sm btn-outline-primary" onClick={() => openEdit(r)}>แก้ไข</button>
                      {/* <button className="btn btn-sm btn-outline-danger" onClick={() => deleteItem(r.id || r.Id)}>ลบ</button> */}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
          {items.length > 0 && (
            <tfoot>
              <tr>
                <td colSpan={5} className="text-end fw-bold">รวมใช้ไป</td>
                <td className="text-center fw-bold">{fmtMoney(items.reduce((a, r) => a + Number(r.compensetionExpense || 0), 0))}</td>
                <td className="text-center fw-bold">{fmtMoney(items.reduce((a, r) => a + Number(r.travellingExpense || 0), 0))}</td>
                <td className="text-center fw-bold">{fmtMoney(items.reduce((a, r) => a + Number(r.materialExpense || 0), 0))}</td>
                <td className="text-center fw-bold">{fmtMoney(summary.spent)}</td>
                <td />
                <td />
              </tr>
            </tfoot>
          )}
        </Table>
      </div>

      {/* Modal เพิ่ม/แก้ไขรายการ (1–1) */}
      <Modal isOpen={openModal} toggle={closeModal} centered size="lg" backdrop="static">
        <ModalHeader toggle={closeModal}>
          {editingItem ? "แก้ไขรายการจ่าย" : "เพิ่มรายการจ่าย"}
        </ModalHeader>
        <ModalBody>
          <ItemForm49
            deptId={deptId}
            reportMonth={reportMonth}
            editingItem={editingItem}
            lawOcuData={lawOcuData}
            testLawOcuData={testLawOcuData}
            loadTestOcc={loadTestOcc}
            onSaved={(savedRow) => {
              if (editingItem) {
                setItems((prev) =>
                  prev.map((x) => (String(x.id || x.Id) === String(savedRow.id || savedRow.Id) ? savedRow : x))
                );
              } else {
                setItems((prev) => [...prev, savedRow]);
              }
              closeModal();
            }}
          />
        </ModalBody>
      </Modal>

      {loading && (
        <div className="position-fixed bottom-0 end-0 p-3">
          <div className="badge bg-secondary">กำลังโหลด...</div>
        </div>
      )}
    </Container>
  );
}

// ===================== Item Form (ชอ.4–9) =====================
function ItemForm49({ deptId, reportMonth, editingItem, lawOcuData, testLawOcuData, loadTestOcc, onSaved }) {
  const { y, m } = parseYearMonth(reportMonth || "2000-01");

  const schema = Yup.object().shape({
    lawOccupationId: Yup.string().required("กรุณาเลือกสาขาอาชีพ"),
    testOccupationId: Yup.string().required("กรุณาเลือกสาขา"),
    personTest: Yup.number().typeError("กรอกเป็นตัวเลข").min(0).required("กรอกจำนวน"),
    passEvaluation: Yup.number().typeError("กรอกเป็นตัวเลข").min(0).required("กรอกจำนวน"),
    compensetionExpense: Yup.number().typeError("กรอกเป็นตัวเลข").min(0).required("กรอกจำนวน"),
    travellingExpense: Yup.number().typeError("กรอกเป็นตัวเลข").min(0).required("กรอกจำนวน"),
    materialExpense: Yup.number().typeError("กรอกเป็นตัวเลข").min(0).required("กรอกจำนวน"),
    paymentDate: Yup.string().required("กรุณาเลือกวันที่จ่าย"),
  });

  const initial = {
    id: editingItem?.id || editingItem?.Id || null,
    deptId,
    lawOccupationId: editingItem?.lawOccupationId || "",
    testOccupationId: editingItem?.testOccupationId || "",
    personTest: editingItem?.personTest ?? 0,
    passEvaluation: editingItem?.passEvaluation ?? editingItem?.passevaluaTion ?? 0,
    compensetionExpense: editingItem?.compensetionExpense ?? 0,
    travellingExpense: editingItem?.travellingExpense ?? 0,
    materialExpense: editingItem?.materialExpense ?? 0,
    paymentDate: editingItem?.paymentDate || "", // yyyy-MM-dd
    testOccupationLevel: editingItem?.testOccupationLevel || "1",
    createBy: editingItem?.createBy || "",
  };

  return (
    <Formik
      initialValues={initial}
      validationSchema={schema}
      onSubmit={async (values, actions) => {
        try {
          if (!values.paymentDate) {
            Swal.fire("กรุณาเลือกวันที่จ่าย", "", "warning");
            return;
          }
          if (!sameMonth(values.paymentDate, y, m)) {
            Swal.fire("วันที่จ่ายต้องอยู่ในเดือนที่เลือก", "", "error");
            return;
          }

          const body = {
            Id: values.id,
            DeptId: values.deptId,
            LawOccupationId: values.lawOccupationId,
            TestOccupationId: values.testOccupationId,
            TestOccupationLevel: values.testOccupationLevel || "1",
            PersonTest: Number(values.personTest || 0),
            PassEvaluation: Number(values.passEvaluation || 0),
            CompensationExpense: Number(values.compensetionExpense || 0),
            TravellingExpense: Number(values.travellingExpense || 0),
            MaterialExpense: Number(values.materialExpense || 0),
            PaymentDate: values.paymentDate,
            CreateBy: values.createBy,
          };

          const res = await fetch("/api/Support/addViewdata49", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(body),
          });
          const j = await res.json();
          if (j?.status === 1) {
            // enrich ชื่อสาขา
            const lawName =
              lawOcuData.find((x) => String(x.lawOccupationId) === String(values.lawOccupationId))?.lawOccupationName || "-";
            const testName =
              testLawOcuData.find((x) => String(x.testOccupationCode) === String(values.testOccupationId))?.testOccupationName ||
              editingItem?.testOccupationName || "-";

            const savedRow = {
              ...values,
              id: values.id || j.id,
              lawOccupationName: lawName,
              testOccupationName: testName,
            };

            Swal.fire("บันทึกรายการสำเร็จ", "", "success");
            onSaved && onSaved(savedRow);
          } else {
            Swal.fire("บันทึกไม่สำเร็จ", j?.message || "", "warning");
          }
        } catch {
          Swal.fire("บันทึกไม่สำเร็จ", "", "error");
        } finally {
          actions.setSubmitting(false);
        }
      }}
      enableReinitialize
    >
      {({ values, setFieldValue, handleChange, touched, errors }) => {
        const selectedDate = values.paymentDate
          ? utcToZonedTime(new Date(values.paymentDate), "Asia/Bangkok")
          : null;
        const be = selectedDate ? addYears(543, selectedDate) : null;
        const beLabel = be
          ? `${format(be, "dd")} ${format(be, "MMMM", { locale: th })} ${format(be, "yyyy")}`
          : "";

        const totalRow =
          Number(values.compensetionExpense || 0) +
          Number(values.travellingExpense || 0) +
          Number(values.materialExpense || 0);

        return (
          <Form>
            <Row className="g-3">
              <Col md={6}>
                <Label>สาขาอาชีพ</Label>
                <Field name="lawOccupationId">
                  {({ field }) => (
                    <Input
                      type="select"
                      className={`rounded-pill text-center ${touched.lawOccupationId && errors.lawOccupationId ? "is-invalid" : ""}`}
                      {...field}
                      onChange={async (e) => {
                        handleChange(e);
                        await loadTestOcc(e.target.value);
                        setFieldValue("testOccupationId", "");
                      }}
                    >
                      <option value="">กรุณาเลือกสาขาอาชีพ</option>
                      {lawOcuData.map((law) => (
                        <option key={law.lawOccupationId} value={law.lawOccupationId}>
                          {law.lawOccupationName}
                        </option>
                      ))}
                    </Input>
                  )}
                </Field>
                {touched.lawOccupationId && errors.lawOccupationId && (
                  <div className="invalid-feedback d-block">{errors.lawOccupationId}</div>
                )}
              </Col>

              <Col md={6}>
                <Label>สาขา</Label>
                <Field name="testOccupationId">
                  {({ field }) => (
                    <Input
                      type="select"
                      className={`rounded-pill text-center ${touched.testOccupationId && errors.testOccupationId ? "is-invalid" : ""}`}
                      {...field}
                    >
                      <option value="">กรุณาเลือกสาขา</option>
                      {testLawOcuData.map((it) => (
                        <option key={it.testOccupationCode} value={it.testOccupationCode}>
                          {it.testOccupationName}
                        </option>
                      ))}
                    </Input>
                  )}
                </Field>
                {touched.testOccupationId && errors.testOccupationId && (
                  <div className="invalid-feedback d-block">{errors.testOccupationId}</div>
                )}
              </Col>

              <Col md={6}>
                <Label>ผู้เข้ารับการทดสอบ (คน)</Label>
                <Field name="personTest">
                  {({ field }) => (
                    <Input
                      type="number"
                      min="0"
                      {...field}
                      className={`rounded-pill text-center ${touched.personTest && errors.personTest ? "is-invalid" : ""}`}
                    />
                  )}
                </Field>
                {touched.personTest && errors.personTest && (
                  <div className="invalid-feedback d-block">{errors.personTest}</div>
                )}
              </Col>

              <Col md={6}>
                <Label>ผู้ผ่านการทดสอบ (คน)</Label>
                <Field name="passEvaluation">
                  {({ field }) => (
                    <Input
                      type="number"
                      min="0"
                      {...field}
                      className={`rounded-pill text-center ${touched.passEvaluation && errors.passEvaluation ? "is-invalid" : ""}`}
                    />
                  )}
                </Field>
                {touched.passEvaluation && errors.passEvaluation && (
                  <div className="invalid-feedback d-block">{errors.passEvaluation}</div>
                )}
              </Col>

              <Col md={6}>
                <Label>ค่าตอบแทนนอกเวลาราชการ (บาท)</Label>
                <Field name="compensetionExpense">
                  {({ field }) => (
                    <Input
                      type="number"
                      min="0"
                      step="0.01"
                      {...field}
                      className={`rounded-pill text-center ${touched.compensetionExpense && errors.compensetionExpense ? "is-invalid" : ""}`}
                    />
                  )}
                </Field>
                {touched.compensetionExpense && errors.compensetionExpense && (
                  <div className="invalid-feedback d-block">{errors.compensetionExpense}</div>
                )}
              </Col>

              <Col md={6}>
                <Label>ค่าเดินทาง (บาท)</Label>
                <Field name="travellingExpense">
                  {({ field }) => (
                    <Input
                      type="number"
                      min="0"
                      step="0.01"
                      {...field}
                      className={`rounded-pill text-center ${touched.travellingExpense && errors.travellingExpense ? "is-invalid" : ""}`}
                    />
                  )}
                </Field>
                {touched.travellingExpense && errors.travellingExpense && (
                  <div className="invalid-feedback d-block">{errors.travellingExpense}</div>
                )}
              </Col>

              <Col md={6}>
                <Label>ค่าวัสดุ (บาท)</Label>
                <Field name="materialExpense">
                  {({ field }) => (
                    <Input
                      type="number"
                      min="0"
                      step="0.01"
                      {...field}
                      className={`rounded-pill text-center ${touched.materialExpense && errors.materialExpense ? "is-invalid" : ""}`}
                    />
                  )}
                </Field>
                {touched.materialExpense && errors.materialExpense && (
                  <div className="invalid-feedback d-block">{errors.materialExpense}</div>
                )}
              </Col>

              <Col md={6}>
                <Label>รวม (บาท)</Label>
                <Input
                  type="text"
                  value={totalRow.toLocaleString(undefined, { maximumFractionDigits: 2 })}
                  readOnly
                  className="rounded-pill text-center"
                />
              </Col>

              <Col md={6}>
                <Label>วันที่จ่ายเงินช่วยเหลือ/อุดหนุน</Label>
                <DatePicker
                  selected={values.paymentDate ? utcToZonedTime(new Date(values.paymentDate), "Asia/Bangkok") : null}
                  locale="th-buddhist"
                  calendarClassName="thai-buddhist"
                  dateFormat="dd MMMM yyyy"
                  value={values.paymentDate ? toThaiDateLabel(values.paymentDate) : ""}
                  isClearable
                  placeholderText="กรุณาเลือก"
                  renderCustomHeader={({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => (
                    <div className="react-datepicker__custom-header d-flex justify-content-between align-items-center">
                      <button type="button" className="react-datepicker__navigation react-datepicker__navigation--previous"
                        onClick={decreaseMonth} disabled={prevMonthButtonDisabled} aria-label="previous month">
                        <span className="react-datepicker__navigation-icon react-datepicker__navigation-icon--previous" />
                      </button>
                      <div>
                        <select value={thaiMonths[(values.paymentDate ? new Date(values.paymentDate) : date).getMonth()]}
                          onChange={({ target: { value } }) => changeMonth(thaiMonths.indexOf(value))}>
                          {thaiMonths.map((option) => <option key={option} value={option}>{option}</option>)}
                        </select>
                        <select
                          value={(values.paymentDate ? new Date(values.paymentDate) : date).getFullYear()}
                          onChange={({ target: { value } }) => changeYear(value)}
                        >
                          {years.map((option) => <option key={option} value={option}>{Number(option) + 543}</option>)}
                        </select>
                      </div>
                      <button type="button" className="react-datepicker__navigation react-datepicker__navigation--next"
                        onClick={increaseMonth} disabled={nextMonthButtonDisabled} aria-label="next month">
                        <span className="react-datepicker__navigation-icon react-datepicker__navigation-icon--next" />
                      </button>
                    </div>
                  )}
                  onChange={(date) => {
                    if (date instanceof Date && !isNaN(date)) {
                      const y2 = date.getFullYear();
                      const m2 = String(date.getMonth() + 1).padStart(2, "0");
                      const d2 = String(date.getDate()).padStart(2, "0");
                      const iso = `${y2}-${m2}-${d2}`;
                      // ป้องกันผิดเดือน (UX)
                      const { y, m } = parseYearMonth(reportMonth || "2000-01");
                      if (!sameMonth(iso, y, m)) {
                        Swal.fire("วันที่จ่ายต้องอยู่ในเดือนที่เลือก", "", "error");
                        return;
                      }
                      setFieldValue("paymentDate", iso);
                    } else {
                      setFieldValue("paymentDate", "");
                    }
                  }}
                  customInput={
                    <Input
                      type="text"
                      value={values.paymentDate ? toThaiDateLabel(values.paymentDate) : ""}
                      readOnly
                      className={`rounded-pill text-center ${(!values.paymentDate && (touched.paymentDate || false)) ? "is-invalid" : ""}`}
                    />
                  }
                />
                {touched.paymentDate && !values.paymentDate && (
                  <div className="invalid-feedback d-block">กรุณาเลือกวันที่จ่าย</div>
                )}
              </Col>
            </Row>

            <div className="d-flex justify-content-between mt-4">
              <button type="button" className="btn btn-outline-secondary" onClick={() => window.history.back?.()}>ยกเลิก</button>
              <button type="submit" className="btn btn-success">{editingItem ? "บันทึกการแก้ไข" : "บันทึกรายการ"}</button>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
}
